import React from "react";
import { TextInput, maxLength } from "react-admin";
import { useFormState } from "react-final-form";

import { makeFormatter } from "../../../../components/formatter";
import { requiredIfTrue } from "../../../../utils/validation/requiredIfNoFieldValue";

const TRIP_NUMBER_MAX_LENGTH = 16;

const tripNumberFormatter = makeFormatter([
	// { char: /\d/, repeat: 3 },
	// { exactly: "-" },
	// { char: /\d/, repeat: 2 },
	// { char: /[a-z]/i }
	{ char: /[\d\w]/i, repeat: TRIP_NUMBER_MAX_LENGTH },
]);

export const TripNumberInput = ({ validate = [], ...props }) => {
	const { values } = useFormState();
	if (validate !== null) {
		validate = [maxLength(TRIP_NUMBER_MAX_LENGTH), ...validate];
	}
	return <TextInput parse={tripNumberFormatter} validate={validate} {...props} />;
};
